import React, { useCallback, useContext, useEffect } from 'react';
import VesselAutoComplete from 'components/common/VesselAutoComplete';
import { selectTypes } from '../../TcIndex/common';
import { VesselDwtTypesContext } from '../HiresPage';
import { TableRowColumn } from 'material-ui';
import styles from '../../TcIndex/styles';

export function generateSpeedConsString(s) {
    if (
        !s.speed &&
        !s.mode &&
        (!s.ifo || !s.ifo.cons) &&
        (!s.mdo || !s.mdo.cons)
    ) return '';

    const ifoString = s.ifo ? `${s.ifo.typeIfo || ''} - ${s.ifo.cons || ''}` : '';
    const mdoString = s.mdo ? `${s.mdo.typeMdo || ''} - ${s.mdo.cons || ''}` : '';
    
    return `Mode: ${s.mode} | Speed: ${s.speed || '-'} | Ifo: ${ifoString} | Mdo: ${mdoString}`;
}

const PRIORITY_MODES = ['Eco Laden', 'Eco Ballast', 'Laden', 'Ballast', 'Working', 'Idle'];

const selectBestSpeedCons = (speedConsData) => {
    if (!speedConsData || !speedConsData.length) return {};

    // find first available mode by priority
    // eslint-disable-next-line no-restricted-syntax
    for (const mode of PRIORITY_MODES) {
        const modeEntries = speedConsData.filter(s => s.mode === mode);
        if (modeEntries.length) {
            // if multiple entries of same mode exist, get one with the highest speed
            return modeEntries.reduce((best, current) => {
                if (current.speed > best.speed) return current;
                if (current.speed === best.speed) {
                    // сompare total consumption (ifo + mdo) if speeds are equal
                    const bestTotalCons = 
                        (best.ifo && best.ifo.cons && !isNaN(best.ifo.cons) ? best.ifo.cons : 0) + 
                        (best.mdo && best.mdo.cons && !isNaN(best.mdo.cons) ? best.mdo.cons : 0);
                    const currentTotalCons = 
                        (current.ifo && current.ifo.cons && !isNaN(current.ifo.cons) ? current.ifo.cons : 0) + 
                        (current.mdo && current.mdo.cons && !isNaN(current.mdo.cons) ? current.mdo.cons : 0);
                    if (currentTotalCons > bestTotalCons) return current;
                }
                return best;
            }, modeEntries[0]);
        }
    }
    return {};
};

const VesselColumn = ({ children }) => (
    <TableRowColumn style={{ ...styles.tableRowSm, fontSize: '9px' }}>
        {children || ''}
    </TableRowColumn>
);

const spawnVesselInfoCols = vesselData => (
    <React.Fragment>
        <VesselColumn>
            {vesselData && vesselData.typeByPurpose}
        </VesselColumn>
        <VesselColumn>
            {vesselData && vesselData.typeByConstruction}
        </VesselColumn>
        <VesselColumn>
            {vesselData && vesselData.imoNumber && 
                (typeof vesselData.geared === 'boolean' ? String(vesselData.geared) : undefined)}
        </VesselColumn>
        <VesselColumn>
            {vesselData && vesselData.gearV2 && vesselData.gearV2.summary && 
                vesselData.gearV2.summary.reduce((max, s) => Math.max(max, s.capacity), 0)}
        </VesselColumn>
        <VesselColumn>
            {vesselData && vesselData.speedConsumptionV2 &&
                generateSpeedConsString(selectBestSpeedCons(vesselData.speedConsumptionV2))}
        </VesselColumn>
    </React.Fragment>
);

function VesselInfo({
    vessel: _vessel, countIndex, changeFieldsMultiple, required, setHasErrors,
}) {
    const vesselDwtTypes = useContext(VesselDwtTypesContext);

    useEffect(() => {
        if (required) {
            if (!_vessel || !_vessel._id) {
                setHasErrors('vessel', true);
            } else {
                setHasErrors('vessel', false);
            }
        }
    }, [_vessel ? _vessel._id : _vessel]);

    const selectVessel = (vessel) => {
        const vesselData = selectTypes(vessel, vesselDwtTypes);
        
        changeFieldsMultiple([
            {
                index: countIndex,
                field: 'vessel',
                value: vessel,
            },
            {
                index: countIndex,
                field: 'vesselDwtGroup',
                value: vesselData.vesselDwtGroup,
            },
        ]);
    };

    return (
        <React.Fragment>
            <TableRowColumn style={{ ...styles.tableRow }}>
                <VesselAutoComplete
                    customValue={_vessel ? _vessel.name : ''}
                    selectValue={selectVessel}
                    hintText={null}
                    underlineStyle={{ display: 'none' }}
                    menuStyle={{ width: '300px' }}
                    popoverProps={{
                        style: { width: '300px' },
                    }}
                    inputStyle={{ fontSize: '9px' }}
                    dataSourceConfig={{
                        withName: true,
                        withBlt: true,
                        withImo: true,
                    }}
                />
            </TableRowColumn>
            {spawnVesselInfoCols(_vessel)}
        </React.Fragment>
    );
}

export default React.memo(VesselInfo, (prevProps, nextProps) => {
    if (!prevProps.vessel || !nextProps.vessel) return prevProps.vessel === nextProps.vessel;
    
    return (
        prevProps.vessel._id === nextProps.vessel._id &&
        prevProps.vessel.typeByPurpose === nextProps.vessel.typeByPurpose &&
        prevProps.vessel.typeByConstruction === nextProps.vessel.typeByConstruction &&
        prevProps.vessel.geared === nextProps.vessel.geared &&
        prevProps.vessel.speedConsumptionV2 === nextProps.vessel.speedConsumptionV2
    );
});



// WEBPACK FOOTER //
// ./app/components/Hires/rowData/VesselInfo.jsx